import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { getWechatBindingPresentation } from '@/components/WechatSignIn/presentation';
import useContextualSignInFrame from '@/hooks/use-contextual-sign-in-frame';
import { layoutClassNames } from '@/utils/consts';
import {
  getContextualSignInPage,
  isContextualSignInEmbedded,
} from '@/utils/contextual-sign-in-page';

import VibeHubBrand from './VibeHubBrand';
import styles from './index.module.scss';

const AppLayout = () => {
  const { i18n } = useTranslation();
  const contextual = getContextualSignInPage();
  const isEmbedded = isContextualSignInEmbedded(contextual);
  const content = useContextualSignInFrame(isEmbedded, contextual?.parentOrigin);
  if (contextual ?? getWechatBindingPresentation()) {
    return (
      <div
        data-contextual-auth="true"
        className={classNames(styles.contextual, isEmbedded && styles.embedded)}
      >
        <main
          ref={content}
          className={classNames(styles.contextualMain, layoutClassNames.mainContent)}
        >
          <Outlet />
        </main>
      </div>
    );
  }
  const isChinese = i18n.resolvedLanguage?.toLowerCase().startsWith('zh') ?? false;

  return (
    <div className={styles.viewBox}>
      <VibeHubBrand />
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
        </main>
      </div>
      <footer className={styles.footer}>
        <p className={styles.trust}>
          {isChinese ? '身份服务由 VibeHub 安全托管' : 'Identity securely hosted by VibeHub'}
        </p>
      </footer>
    </div>
  );
};

export default AppLayout;
